import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ({ items = [], accent = "pink", title = "FAQ" }) {
  const accentColor = accent === "blue" ? "var(--leen-blue)" : "var(--leen-pink)";
  return (
    <section className="bg-[var(--leen-bg)] py-20 md:py-28 border-t border-[var(--leen-line)]">
      <div className="px-5 md:px-8 lg:px-12 max-w-[1100px] mx-auto">
        <div className="text-center mb-12">
          <p className="font-script text-[var(--leen-pink)] text-[44px] md:text-[60px] leading-none italic -mb-2" style={{ color: accentColor }}>
            Got
          </p>
          <h2 className="font-display text-[36px] sm:text-[52px] md:text-[64px] leading-none text-white">
            {title}
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[var(--leen-card)] border border-[var(--leen-line)] rounded-xl px-5 md:px-7 data-[state=open]:border-[var(--leen-pink)]"
            >
              <AccordionTrigger className="font-display text-[16px] md:text-[20px] text-white tracking-wide hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-[14px] md:text-[15px] text-[var(--leen-ink-soft)] leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
